import * as z from 'zod'

/**
 * Base schema for payloads passed from Rails backend to React templates.
 * All resource page payloads extend this base structure.
 */
export const BasePayloadSchema = z.lazy(() =>
  z.object({
    contentfulRawJsonResponse: z.looseObject({}),
    userLoggedIn: z.boolean().optional(),
  }),
)

export type BasePayload = z.infer<typeof BasePayloadSchema>

/**
 * @deprecated Use BasePayloadSchema instead
 */
export const PayloadSchema = BasePayloadSchema
export type Payload = BasePayload

export function toPayload(payload: unknown): Payload {
  return BasePayloadSchema.parse(payload)
}
